import React, { Component, Fragment } from 'react'
import { Button, message, Modal } from 'antd'
import EditRowModalPurpose from 'Components/EditRowModalPurpose'
import { AlignRightColumn, WhiteTable } from 'Common/styled'

import { formats, refsTableLocale } from 'Common/constants'
import { numeral } from 'Common/global'
import * as _ from 'lodash'
import { agreementState, userType } from '../../common/constants'


class SelectedPurposeTable extends Component {
    state = {
        isRealQuantityEditable: false,
        isPickedUpQuantityEditable: false,
        isShippedQuantityEditable: false,
        isReceivedQuantityEditable: false,
        isSupplyChainChangeReasonEditable: false,
        columns: []
    }

    baseColumns = [
        {
            title: 'Ref. LM',
            dataIndex: 'refLm',
            key: 'refLm'
        },
        {
            title: 'Descrizione',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Gamma',
            dataIndex: 'gamma',
            key: 'gamma'
        },
        {
            title: 'Qtà stock',
            dataIndex: 'storeStock',
            key: 'storeStock',
            render: value => {
                return numeral(value).format(formats.number)
            }
        },
        {
            title: 'Qtà accettata',
            dataIndex: 'acceptedStock',
            key: 'acceptedStock',
            render: value => {
                return numeral(value).format(formats.number)
            }
        }
    ]

    realQuantityCol = {
        title: 'Qtà effettiva',
        dataIndex: 'realStock',
        key: 'realStock',
        render: (text, record) => {
            return {
                props: {
                    className: this.state.isRealQuantityEditable ?
                        'editable-col' : ''
                },
                children: numeral(text).format(formats.number)
            }
        }
    }

    pickedUpQuantityCol = {
        title: 'Qtà da ritirare',
        dataIndex: 'withdrawnStock',
        key: 'withdrawnStock',
        render: (value, record) => {
            return {
                props: {
                    className: this.state.isPickedUpQuantityEditable ?
                        'editable-col' : ''
                },
                children: numeral(value).format(formats.number)
            }
        }
    }

    shippedQuantityCol = {
        title: 'Qtà spedita',
        dataIndex: 'shippedStock',
        key: 'shippedStock',
        render: value => {
            return {
                props: {
                    className: this.state.isShippedQuantityEditable ?
                        'editable-col' : ''
                },
                children: numeral(value).format(formats.number)
            }
        }
    }

    receivedQuantityCol = {
        title: 'Qtà ricevuta',
        dataIndex: 'deliveredStock',
        key: 'deliveredStock',
        render: value => {
            return {
                props: {
                    className: this.state.isReceivedQuantityEditable ?
                        'editable-col' : ''
                },
                children: numeral(value).format(formats.number)
            }
        }
    }

    acceptedPriceCol = {
        title: 'Prezzo accettato',
        dataIndex: 'acceptedPrice',
        key: 'acceptedPrice',
        render: value => {
            return numeral(value).format(formats.currency)
        }
    }

    supplyChainChangeReasonCol = {
        title: 'Motivo rettifica',
        dataIndex: 'supplyChainChangeReason',
        key: 'supplyChainChangeReason',
        render: (value, record) => {
            let reason = "";
            switch (value) {
                case 'OTHER':
                    reason = "Altro motivo";
                    break;
                case "COUNT_ERROR":
                    reason = "Errore conteggio";
                    break;
                case 'DAMAGED_GOODS':
                    reason = "Merce danneggiata";
                    break;
                default:
                    reason = "";
            }
            return {
                props: {
                    className: this.state.isSupplyChainChangeReasonEditable ? 'editable-col' : ''
                },
                children:

                    <span
                        //className={value + 'Field'}
                        id={"supplyChainChangeReasonInpCol_" + record.id.agreementDetailId + '' + record.id.proposalId}
                        placeholder=""
                    >{reason}</span>
            }
        }
    }

    totalAmountCol = {
        title: 'Totale',
        // dataIndex: 'totalAmount',
        key: 'totalAmount',
        render: record =>
            this.getTotalAmount(record)
        //(record.stockQuantity * record.acceptedPrice).toFixed(2)
    }
    actionsCol = {
        key: 'actions',
        render: record =>
            (this.state.isReceivedQuantityEditable ||
                this.state.isRealQuantityEditable ||
                this.state.isPickedUpQuantityEditable ||
                this.state.isShippedQuantityEditable ||
                this.state.isReceivedQuantityEditable ||
                (this.props.selectedAgreement.agreementState === agreementState["1"] &&
                    this.props.user.type === userType.S)
            ) && (

                <Button
                    icon="edit"
                    type="primary"
                    title="Modifica"
                    onClick={() => this.editRow(record)}
                />
            )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.buildColumnsList()
        }
    }

    getTotalAmount(record) {
        if (this.props.tableRules && this.props.tableRules.currentQuantity) {
            let currentQuantity = record[this.props.tableRules.currentQuantity] || 0
            return numeral(currentQuantity * record.acceptedPrice).format(formats.currency)
        }
        return numeral(0).format(formats.currency)
    }

    buildColumnsList = () => {
        let columns = [...this.baseColumns]
        let isEditable = false
        let stateChanges = {
            isRealQuantityEditable: false,
            isPickedUpQuantityEditable: false,
            isShippedQuantityEditable: false,
            isReceivedQuantityEditable: false,
            isSupplyChainChangeReasonEditable: false
        }

        // if ([purposeState[3].key, purposeState[4].key, purposeState[5].key].indexOf(this.props.data.state) > -1) {
        //   if (this.props.user.type === userType.SC.key) {
        //     stateChanges.isSupplyChainChangeReasonEditable = true;
        //   }
        //
        //   columns.push(this.supplyChainChangeReasonCol);
        // }

        this.props.tableRules.fields.forEach(el => {
            switch (el.column) {
                case 'supplyChainChangeReason':
                    if (el.hide === true) {
                        break
                    }

                    columns.push(this.supplyChainChangeReasonCol)

                    if (el.edit) {
                        isEditable = true
                        stateChanges.isSupplyChainChangeReasonEditable = true
                    }

                    break

                case 'realStock':
                    if (el.hide === true) {
                        break
                    }

                    columns.push(this.realQuantityCol)
                    if (el.edit) {
                        isEditable = true
                        stateChanges.isRealQuantityEditable = true
                    }
                    break
                case 'withdrawnStock':
                    if (el.hide === true) {
                        break
                    }

                    columns.push(this.pickedUpQuantityCol)
                    if (el.edit) {
                        isEditable = true
                        stateChanges.isPickedUpQuantityEditable = true
                    }
                    break
                case 'shippedStock':
                    if (el.hide === true) {
                        break
                    }

                    columns.push(this.shippedQuantityCol)
                    if (el.edit) {
                        isEditable = true
                        stateChanges.isShippedQuantityEditable = true
                    }
                    break
                case 'deliveredStock':
                    if (el.hide === true) {
                        break
                    }

                    columns.push(this.receivedQuantityCol)
                    if (el.edit) {
                        isEditable = true
                        stateChanges.isReceivedQuantityEditable = true
                    }
                    break
                default:
                    break
            }
        })
        columns.push(this.acceptedPriceCol)
        columns.push(this.totalAmountCol)
        if (isEditable) {
            columns.push(this.actionsCol)
        }

        stateChanges = {...stateChanges, columns: columns}
        this.setState(stateChanges)
    }

    editRow = row => {
        const {user} = this.props
        let field

        this.props.tableRules.fields.forEach(elem => {
            if (elem.edit) {
                field = elem.column
            }
        })

        // Edit row button opens a modal
        Modal.confirm({
            icon: '',
            okText: 'Conferma',
            cancelText: 'Annulla',
            content: <EditRowModalPurpose tableRules={this.props.tableRules} purposeState={this.props.data.state} row={row} field={field} user={user}/>,
            onOk: () => {
                return new Promise((resolve, reject) => {
                    let tempQuantityRealField = document.getElementById("quantityReal");
                    let tempWithdrawnStock = document.getElementById("withdrawnStock");
                    let tempQuantityShippedField = document.getElementById('quantityShipped');
                    let tempReceivedQntFld = document.getElementById("quantityRecieved");
                    let tempSupplyChangeReason = document.getElementById("supplyChangeReasonValue");

                    if (tempQuantityRealField) {
                        let tempQuantityReal = tempQuantityRealField.value;
                        if (tempQuantityReal > Number(document.getElementById('quantityDefault').textContent)) {
                            message.warning('La quantità inserita supera la quantità massima')
                        }
                        row.realStock = Number(tempQuantityReal);
                        row.withdrawnStock = Number(tempQuantityReal);
                        row.shippedStock = Number(tempQuantityReal);
                        row.deliveredStock = Number(tempQuantityReal);
                        //document.getElementById("realQuantityCol").innerHTML = Number(tempQuantityReal);
                    }

                    if(tempWithdrawnStock) {
                        tempWithdrawnStock = tempWithdrawnStock.value;
                        if (tempWithdrawnStock > Number(document.getElementById('quantityDefault').textContent)) {
                            message.warning('La quantità inserita supera la quantità massima')
                            reject()
                            return
                        }
                        row.withdrawnStock = Number(tempWithdrawnStock);
                        row.shippedStock = Number(tempWithdrawnStock);
                        row.deliveredStock = Number(tempWithdrawnStock);
                        //document.getElementById("realQuantityCol").innerHTML = Number(tempQuantityReal);
                    }

                    if (tempQuantityShippedField) {
                        tempQuantityShippedField = Number(tempQuantityShippedField.value)
                        if (tempQuantityShippedField > Number(document.getElementById('quantityDefault').textContent)) {
                            message.warning('La quantità inserita supera la quantità massima')
                            reject()
                            return
                        }
                        row.shippedStock = Number(tempQuantityShippedField);
                        row.deliveredStock = Number(tempQuantityShippedField);
                    }

                    if (tempReceivedQntFld !== null && tempReceivedQntFld !== undefined) {
                        let tempQuantityRecieved = document.getElementById("quantityRecieved").value;
                        if (tempQuantityRecieved > Number(document.getElementById('quantityDefault').textContent)) {
                            message.warning('La quantità inserita supera la quantità massima')
                            reject()
                            return
                        }
                        row.deliveredStock = Number(tempQuantityRecieved);
                        //document.getElementById("realQuantityCol").innerHTML = Number(tempQuantityReal);
                    }

                    if(tempSupplyChangeReason) {
                        let tempReason = tempSupplyChangeReason.value;
                        if (tempReason !== null && tempReason !== undefined) {
                            let reason = "";
                            switch (tempReason) {
                                case 'OTHER':
                                    reason = "Altro motivo";
                                    break;
                                case "COUNT_ERROR":
                                    reason = "Errore conteggio";
                                    break;
                                case "DAMAGED_GOODS":
                                    reason = "Merce danneggiata";
									break;
								default:
									reason = "ERROR";
                            }
			    if (reason === ""){
					message.warning('Occorre indicare un Motivo Rettifica');
					reject();
					return
			    } else {
				document.getElementById("supplyChainChangeReasonInpCol_" + row.id.agreementDetailId + '' + row.id.proposalId).innerText = reason;
				row.supplyChainChangeReason = tempSupplyChangeReason.value;
			    }
                        }
                    }
                    this.handleSave(row)
                    resolve()
                })
            }
        })
    }

    handleSave = row => {
        // Calculate totalAmount value
        row.totalAmount = (row.proposedPrice * row.stockQuantity).toString()
        // Warning if stockQuantity  is greater than maxQuantity
        if (row.stockQuantity > row.maxQuantity) {
            Modal.warning({
                title: 'Attenzione!',
                content: 'La quantità inserita è maggiore della quantità massima'
            });
        }
        // Overwrite row with new data
        const newData = this.props.data.connections.slice();
        const index = newData.findIndex(item => row.refLm === item.refLm)
        const item = newData[index]

        newData.splice(index, 1, {
            ...item,
            ...row
        })
        const proposal = Object.assign({}, this.props.data);
        proposal.connections = newData

        // Save updated row on Redux store
        this.props.onProposalUpdate(proposal)
    }

    renderTotalAmount = () => {
        const {selectedAgreement} = this.props
        // Calculate sum of totalAmount column (to render it in the table footer)
        const refs = this.props.data.connections
        let sum = 0

        _.forEach(refs, ref => {
            const agreementDetail = _.find(selectedAgreement.agreementDetails, {agreementDetailId: ref.id.agreementDetailId})
            const qty = ref[this.props.tableRules.currentQuantity] || 0
            sum += qty * agreementDetail.acceptedPrice
        })

        return numeral(sum).format(formats.currency)
    }

    componentWillMount() {
        this.buildColumnsList()
    }

    render() {
        const {data, loading} = this.props

        return (
            <Fragment>
                <WhiteTable
                    locale={refsTableLocale}
                    loading={loading === true}
                    dataSource={data.connections}
                    columns={this.state.columns}
                    size="small"
                    rowKey={record => record.refLm}
                    footer={() => (
                        <AlignRightColumn>
                            Totale: {data.connections ? this.renderTotalAmount() : numeral(0).format(formats.currency)}
                        </AlignRightColumn>
                    )}
                />
            </Fragment>
        )
    }
}

export default SelectedPurposeTable



// WEBPACK FOOTER //
// ./src/components/SelectedPurposeTable/index.js